import { Box, Container, Grid, Button } from "@mui/material";
import { Budget } from "../../components/dashboard/budget";
import { Sales } from "../../components/dashboard/sales";
import { TasksProgress } from "../../components/dashboard/tasks-progress";
import { TotalCustomers } from "../../components/dashboard/total-customers";
import { TotalProfit } from "../../components/dashboard/total-profit";
import { TrafficByDevice } from "../../components/dashboard/traffic-by-device";
import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { theme } from "../../theme";
import { useEffect, useState } from "react";
import axios from "axios";

function Dashboard() {
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [isShow, setShow] = useState(false);
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [employee, setEmployee] = useState();
    const [users, setUsers] = useState(null);
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/statistic/getallcustomer`).then((res) => setData(res.data.data));
    }, []);
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [content, setContent] = useState(null);
    const [users2, setUsers2] = useState(false);
    const [nap, setNap] = useState(false);
    const [rut, setRut] = useState(false);
    const [cuoc, setCuoc] = useState(false);
    const [activeTime, setActiveTime] = useState("Hôm nay");

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayoutCustomer>
                    {
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 3,
                                px: { xs: 2, md: 4 },
                                bgcolor: "#f8fafc",
                                minHeight: "100vh",
                                width: "100%",
                                fontFamily: '"Roboto", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important'
                            }}>
                            <Container maxWidth={false} disableGutters sx={{ width: "100%" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}>
                                    <div>
                                        <h2 style={{ margin: 0, color: "#0f172a", fontSize: "22px", fontWeight: 800 }}>Báo cáo đại lý</h2>
                                        <p style={{ margin: "4px 0 0 0", color: "#64748b", fontSize: "14px" }}>Thống kê tổng quan hoạt động của đại lý</p>
                                    </div>
                                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                        {["Hôm nay", "Hôm qua", "Tháng này", "Tháng trước"].map((label) => (
                                            <Button
                                                key={label}
                                                size="small"
                                                onClick={() => setActiveTime(label)}
                                                sx={{
                                                    textTransform: "none",
                                                    px: 2,
                                                    py: 0.8,
                                                    fontSize: "13px",
                                                    fontWeight: activeTime === label ? 700 : 500,
                                                    borderRadius: "6px",
                                                    bgcolor: activeTime === label ? "#0284c7" : "#ffffff",
                                                    color: activeTime === label ? "#ffffff" : "#475569",
                                                    border: activeTime === label ? "1px solid #0284c7" : "1px solid #cbd5e1",
                                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                                    "&:hover": { bgcolor: activeTime === label ? "#0369a1" : "#f1f5f9" }
                                                }}>
                                                {label}
                                            </Button>
                                        ))}
                                    </div>
                                </Box>

                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "16px", marginBottom: "24px", width: "100%" }}>
                                    {[
                                        { title: "Thành viên ĐK hôm nay", value: 0, color: "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)", icon: "👥" },
                                        { title: "Tổng thành viên", value: data?.thanhvien || 0, color: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)", icon: "📈" },
                                        { title: "Tổng tiền nạp", value: (data?.tongnaps || 0).toLocaleString("vi-VN"), color: "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)", icon: "💰" },
                                        { title: "Tổng tiền rút", value: (data?.tongruts || 0).toLocaleString("vi-VN"), color: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)", icon: "💸" },
                                        { title: "Hoàn trả", value: 0, color: "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)", icon: "🔄" },
                                        { title: "Khuyến mãi", value: 0, color: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)", icon: "🎁" },
                                        { title: "Tổng cược", value: (data?.tongcuoc || 0).toLocaleString("vi-VN"), color: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)", icon: "🎲" },
                                        { title: "Tổng thắng", value: 0, color: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)", icon: "🏆" },
                                        { title: "Tổng thua", value: 0, color: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)", icon: "📉" },
                                    ].map((block, idx) => (
                                        <div key={idx} style={{ background: block.color, borderRadius: "12px", padding: "20px", color: "white", display: "flex", alignItems: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
                                            <div style={{ fontSize: "36px", marginRight: "16px", opacity: 0.9 }}>{block.icon}</div>
                                            <div>
                                                <div style={{ fontSize: "13px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px", opacity: 0.95 }}>{block.title}</div>
                                                <div style={{ fontSize: "24px", fontWeight: "800" }}>{block.value}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                
                                <Box sx={{ background: "#ffffff", borderRadius: "12px", p: 3, border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", width: "100%" }}>
                                    <h3 style={{ margin: "0 0 20px 0", color: "#0f172a", fontSize: "17px", fontWeight: 700 }}>Danh sách báo cáo</h3>
                                    <div style={{ textAlign: "center", padding: "40px", color: "#64748b", fontSize: "14px" }}>
                                        Chưa có dữ liệu báo cáo chi tiết
                                    </div>
                                </Box>
                            </Container>
                        </Box>
                    }
                </DashboardLayoutCustomer>
            </ThemeProvider>
        </>
    );
}

export default Dashboard;
